<template>
  <v-menu
    :value="show"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
  >
    <v-list>
      <template v-if="type === 'category'">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>
              <i
                v-if="item.icon !== null"
                :class="`pr-1 ${item.icon}`"
              />
              {{ item.default_translation.name }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.id">
              ID: {{ item.id }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item @click="$emit('create-question', item)">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Add question') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="! item.uncategorized"
          @click="$emit('create-subcategory', item)"
        >
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Add subcategory') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="! item.uncategorized"
          @click="$emit('edit-category', item)"
        >
          <v-list-item-icon>
            <v-icon>mdi-square-edit-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Edit category') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="$emit('remove-category', item)">
          <v-list-item-icon>
            <v-icon>mdi-delete</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Remove category') }}</v-list-item-title>
        </v-list-item>
      </template>

      <template v-else-if="type === 'subcategory'">
        <v-list-item @click="$emit('create-question', item)">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Add question') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="$emit('edit-subcategory', item)">
          <v-list-item-icon>
            <v-icon>mdi-square-edit-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Edit subcategory') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="$emit('remove-subcategory', item)">
          <v-list-item-icon>
            <v-icon>mdi-delete</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Remove subcategory') }}</v-list-item-title>
        </v-list-item>
      </template>

      <template v-else-if="type === 'category-question' || type === 'subcategory-question'">
        <v-list-item @click="$emit('edit-question', item)">
          <v-list-item-icon>
            <v-icon>mdi-square-edit-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Edit question') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="$emit('remove-question', item)">
          <v-list-item-icon>
            <v-icon>mdi-delete</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('Remove question') }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    },
    show: {
      type: Boolean
    },
    type: {
      type: String,
      required: false,
      default: null
    },
    item: {
      type: Object,
      required: false,
      default: null
    }
  }
}
</script>